<!--
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-11-02 11:44:47
 * @Reference:
-->
<template>
    <div>
        <a-select v-model="data1" style="width: 100%" @change="setValue">
            <a-select-option :value="item.value" v-for="(item, index) in selectList" :key=index>
                {{item.name}}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
export default {
  name: 'userSelect',
  props: {
    record: Object,
    value: String
  },
  data () {
    return {
      data1: this.record,
      selectList: []
    }
  },
  syncProps: ['value', 'record'],
  async mounted () {
    this.setSelectList()
  },
  methods: {
    filterQuery () {
      if (this._value) return { '$regex': this._value }
    },
    setSelectList () {

    },
    setValue (value) {
      this._value = value
    }
  }
}
</script>

<style>

</style>
